import type { Routes } from '@angular/router';

import { UserResolver } from '#modules/user/routes/user.resolver';

export const USERS_ROUTES: Routes = [
    {
        path: ':user_id',
        loadComponent: () => import('#modules/user/views/profile/profile.component').then((m) => m.ProfileComponent),
        resolve: { user: UserResolver },
        providers: [UserResolver],
    },
    {
        path: ':user_id/notifications-settings',
        loadComponent: () =>
            import('#modules/user/views/notifications-settings/notifications-settings.component').then(
                (m) => m.NotificationsSettingsComponent
            ),
        resolve: { user: UserResolver },
        providers: [UserResolver],
    },
    {
        path: ':user_id/reports-settings',
        loadChildren: () => import('#modules/reports/routes/user-reports.routes').then((m) => m.USER_REPORTS_ROUTES),
        resolve: { user: UserResolver },
        providers: [UserResolver],
    },
];
